import {ReactNode} from "react";

interface IProps {
    handleClick: () => void,
    children: ReactNode,
    id: string,
    className?: string,
    disabled?: boolean
}

export const PopupItemButton = ({children, id, className = "p-2", disabled, handleClick}: IProps) => {

    return (
        <li id={id}>
            <button
                className={`cursor-pointer hover:bg-neutral-200 w-full disabled:bg-neutral-200 disabled:cursor-default transition-colors ${className}`}
                onClick={handleClick}
                disabled={disabled}
            >
                {children}
            </button>
        </li>
    );
};